import { useDispatch, useSelector } from '@redux';
import { Button, Form, Input, Modal } from 'antd';
import { DynamicObjectType } from 'core/types/common';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { passQCOrders } from '@redux/orders/actions';

const PassQCModal = ({ onCancel }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);
  const currentData = useSelector<DynamicObjectType>(
    (state) => state.orders.currentData,
  );

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      dispatch(
        passQCOrders({
          data: {
            id: currentData?.id,
            data: values,
          },
        }),
      ).then((res: DynamicObjectType) => {
        if (res?.payload?.success) {
          onCancel();
          setLoading(false);
          window.location.reload();
        }
      });
    });
  };

  return (
    <Modal
      open={modal?.passQC?.isOpen}
      onCancel={onCancel}
      footer={null}
      width={443}
      closeIcon={false}
      closable={false}
      title={t('Pass QC')}
    >
      <div className="grid gap-5">
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item name="passQCNote" label="Note">
            <Input.TextArea />
          </Form.Item>
          <div className="flex justify-end items-center gap-2.5">
            <Button className="h-[40px] w-[100px]" onClick={onCancel}>
              {t('button.cancel')}
            </Button>
            <Button
              className="h-[40px] w-[100px]"
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              {t('button.ok')}
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default PassQCModal;
